import { Events } from './services/events.service';
import { AlertService } from 'src/app/services/alert.service';
import { Component, OnInit } from '@angular/core';

import { Platform, NavController } from '@ionic/angular/standalone';
import { AuthService } from './services/auth.service';
import { EnvService } from './services/env.service';
import { MenuController } from '@ionic/angular/standalone';
import { addIcons } from "ionicons";
import { logOut } from "ionicons/icons";
import { IonRouterLink } from "@ionic/angular/standalone";

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    public selectedIndex = 0;
    public appPages = [
        //    { title: 'Home', url: '/home', icon: 'home' },
        //    { title: 'Quote', url: '/quote', icon: 'document-text' },
    ];

    constructor(
        private platform: Platform,
        private authService: AuthService,
        private alertService: AlertService,
        private navCtrl: NavController,
        private events: Events,
        public env: EnvService,
        private menuCtrl: MenuController
    ) {
        console.log('x-client-appcomponent-constructor');
        this.initializeApp();
        addIcons({ logOut });
    }

    async initializeApp() {
        this.platform.ready()
            .then(async () => {
                console.log('x-client-appcomponent-initializeapp', 'Iframe detected: ' + (window.location !== window.parent.location));
                // If the windows location is not the same as its parent location, then the window is 
                // embedded into an iFrame, which means it needs to get the phpsession if from the parent,
                // so that this can be used later on 
                if (window.location !== window.parent.location) {
                    this.menuCtrl.enable(false);
                    let res = await this.authService.phpSession();
                    console.log('x-client-appcomponent-initializeapp-phpSession-res', res);
                    if (res) {
                        this.authService.credentials.phpsessid = res;
                    }
                }
                else {
                    this.env.isEmbedded = false;
                }
            });

    }

    ngOnInit() {
    }

    // When Logout Button is pressed 
    logout() {
        this.authService.logout().then((data) => {
            this.alertService.popupToast('Logged out', 2000);
            this.navCtrl.navigateRoot('/login');
        },
            (error) => {
                console.log(error);
            });
    }

}
